export const API_HOST = process.env.NODE_ENV === 'development' ? "http://localhost:3001" : "https://bingo-api.serv2.nohns.dk";
